import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { pageViewEvent, ctaClickEvent } from "../services/adobeDataLayer";

function Thankyou() {
    const [showSection, setThankYou] = useState(false);
    const [executed, setExecuted] = useState(false);
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/");
        ctaClickEvent("Back", "Thank you page", "button", 0, "na");
    };

    //   useEffect(() => {

    // if (!executed) {

    //   window.dataLayer.push({
    //     event: "savingsAccount_ty_eligible",
    //   });

    //   console.log("dataLayer", window.dataLayer);
    //   setExecuted(true);
    // }

    //   }, []);

    // Gtags

    useEffect(() => {
        // Inject gtag.js only once
        if (!document.getElementById("gtag-js")) {
            const script = document.createElement("script");
            script.id = "gtag-js";
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id=AW-848956189"; // only one is needed
            document.head.appendChild(script);
        }

        const initGtag = () => {
            window.dataLayer = window.dataLayer || [];

            function gtag() {
                window.dataLayer.push(arguments);
            }

            window.gtag = gtag;

            // Initialize gtag with both Ads tracking IDs
            gtag("js", new Date());
            gtag("config", "AW-848956189");
            // gtag("config", "AW-818835661");
            gtag("config", "AW-858657413");
        };

        // Initialize if already loaded, else wait for it
        if (window.gtag) {
            window.gtag("config", "AW-848956189");
            // window.gtag("config", "AW-818835661");
            window.gtag("config", "AW-858657413");
        } else {
            const existingScript = document.getElementById("gtag-js");
            existingScript?.addEventListener("load", initGtag);
        }
    }, []);



    // //fb tags
    // useEffect(() => {
    //   // Inject fbq script only once
    //   if (!window.fbq) {
    //     (function (f, b, e, v, n, t, s) {
    //       if (f.fbq) return;
    //       n = f.fbq = function () {
    //         n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    //       };
    //       if (!f._fbq) f._fbq = n;
    //       n.push = n;
    //       n.loaded = true;
    //       n.version = '2.0';
    //       n.queue = [];
    //       t = b.createElement(e);
    //       t.async = true;
    //       t.src = v;
    //       s = b.getElementsByTagName(e)[0];
    //       s.parentNode.insertBefore(t, s);
    //     })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    //   }

    //   // Wait a bit to ensure script is loaded, then initialize pixels
    //   const initPixels = () => {
    //     if (!window.fbq) return;
    //     // Initialize both pixels
    //     // window.fbq('init', '1584375811875352');
    //     window.fbq('init', '1109423764622443');

    //     // Track PageView event on both pixels
    //     window.fbq('track', 'PageView');
    //   };

    //   // If fbq loaded, init pixels immediately, else wait for script load
    //   if (window.fbq && window.fbq.loaded) {
    //     initPixels();
    //   } else {
    //     const script = document.querySelector("script[src='https://connect.facebook.net/en_US/fbevents.js']");
    //     if (script) {
    //       script.addEventListener('load', initPixels);
    //     } else {
    //       const scriptEl = document.createElement('script');
    //       scriptEl.async = true;
    //       scriptEl.src = 'https://connect.facebook.net/en_US/fbevents.js';
    //       scriptEl.onload = initPixels;
    //       document.head.appendChild(scriptEl);
    //     }
    //   }

    //   // Optionally add noscript tags somewhere globally (outside React or in index.html)
    // }, []);

    //fb pixels
    useEffect(() => {
        window.spdt('lead'); // spotify
    }, []);

    // DC tags tag
    //   useEffect(() => {
    //     // Load gtag.js script
    //     const script = document.createElement('script');
    //     script.src = "https://www.googletagmanager.com/gtag/js?id=DC-8971752";
    //     script.async = true;
    //     document.head.appendChild(script);

    //     // Initialize gtag after script loads
    //     script.onload = () => {
    //       window.dataLayer = window.dataLayer || [];
    //       function gtag() { window.dataLayer.push(arguments); }
    //       window.gtag = gtag; // make globally available
    //       gtag('js', new Date());
    //       gtag('config', 'DC-8971752');
    //     };

    //     // Cleanup script if component unmounts
    //     return () => {
    //       document.head.removeChild(script);
    //     };
    //   }, []);

    //   Twitter tag
    useEffect(() => {
        const type = localStorage.getItem("type");
        // Fire the event based on type
        if (type === "1") {
            window.twq('config', 'py3bg');
            window.twq('event', 'tw-py3bg-q9hdv', {});
        } else {
            window.twq('config', 'py3bg');
            window.twq('event', 'tw-py3bg-q9hdu', {});
        }
    }, []);


    //LinkedIn tag
    useEffect(() => {
        // Set LinkedIn Partner ID
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push("7810465");

        // Create script tag for LinkedIn insight.min.js
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";

        const firstScript = document.getElementsByTagName("script")[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(script, firstScript);
        }

        // Optional: Clean up the script on unmount
        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);

    //bing tag
    useEffect(() => {
        // Initialize UET queue if not already
        window.uetq = window.uetq || [];

        // Create the Bing UET script
        const script = document.createElement("script");
        script.src = "//bat.bing.com/bat.js";
        script.async = true;

        script.onload = script.onreadystatechange = function () {
            const rs = this.readyState;
            if (!rs || rs === "loaded" || rs === "complete") {
                const o = {
                    ti: "97123908",
                    enableAutoSpaTracking: true,
                };
                o.q = window.uetq;
                window.uetq = new window.UET(o);
                window.uetq.push("pageLoad");

                script.onload = script.onreadystatechange = null;
            }
        };

        const firstScript = document.getElementsByTagName("script")[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(script, firstScript);
        }

        // Optional cleanup
        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);

    // Tag triggers
    useEffect(() => {
        const type = localStorage.getItem("type");
        setThankYou(type);
        //not-eligible
        if (type === "1") {
            pageViewEvent("not eligible");

            // //NEL  Google Ads Conversion for Not Eligible
            // if (typeof window.gtag === "function") {
            //     window.gtag("event", "conversion", {
            //         send_to: "AW-818835661/sSFUCI_X3v0aEM3huYYD",
            //     });
            // }

            //NEL invmedia
            const script = document.createElement("script");
            script.src = "https://www.googletagmanager.com/gtag/js?id=DC-8971752";
            script.async = true;
            document.head.appendChild(script);

            // Initialize gtag after script loads
            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    window.dataLayer.push(arguments);
                }
                window.gtag = gtag; // make globally available
                gtag("js", new Date());
                gtag("config", "DC-8971752");
                gtag("event", "conversion", {
                    allow_custom_scripts: true,
                    send_to: "DC-8971752/invmedia/hhiu-00+standard",
                });
            };

            // NEL Twitter
            // if (typeof window.twq === "function") {
            //     // Insert Twitter Event ID
            //     window.twq("event", "tw-py3bg-q9hdv", {});
            // }

            // NEL FB tags
            const loadFbqScript = () => {
                return new Promise((resolve) => {
                    if (window.fbq) return resolve(); // Already loaded
                    (function (f, b, e, v, n, t, s) {
                        if (f.fbq) return;
                        n = f.fbq = function () {
                            n.callMethod
                                ? n.callMethod.apply(n, arguments)
                                : n.queue.push(arguments);
                        };
                        if (!f._fbq) f._fbq = n;
                        n.push = n;
                        n.loaded = true;
                        n.version = "2.0";
                        n.queue = [];
                        t = b.createElement(e);
                        t.async = true;
                        t.src = v;
                        s = b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t, s);
                        t.onload = resolve;
                    })(
                        window,
                        document,
                        "script",
                        "https://connect.facebook.net/en_US/fbevents.js"
                    );
                });
            };

            const initializePixels = () => {
                if (!window.fbq) return;

                // Initialize both pixels
                window.fbq("init", "1584375811875352"); // Pixel A
                window.fbq("init", "1109423764622443"); // Pixel B
                // Send PageView only to each separately (to avoid duplication)
                // window.fbq("trackSingle", "1584375811875352", "PageView");
                // window.fbq("trackSingleCustom", "1109423764622443", "PageView");
                window.fbq("trackSingle", "1584375811875352", "HHIU-NELTY");
                window.fbq("trackSingleCustom", "1109423764622443", "HHIU-New-XELTY");
            };

            loadFbqScript().then(() => {
                initializePixels();
            });
        }

        else {

            // EL Adobe Event
            pageViewEvent("eligible");

            //EL invmedia
            const script = document.createElement("script");
            script.src = "https://www.googletagmanager.com/gtag/js?id=DC-8971752";
            script.async = true;
            document.head.appendChild(script);

            // Initialize gtag after script loads
            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    window.dataLayer.push(arguments);
                }
                window.gtag = gtag; // make globally available
                gtag("js", new Date());
                gtag("config", "DC-8971752");
                gtag("event", "conversion", {
                    allow_custom_scripts: true,
                    send_to: "DC-8971752/invmedia/hhiu-000+standard",
                });
            };

            // //EL Twitter
            // if (typeof window.twq === "function") {
            //     window.twq("event", "tw-py3bg-q9hdu", {});
            // }

            // EL FB tags
            const loadFbqScript = () => {
                return new Promise((resolve) => {
                    if (window.fbq) return resolve(); // Already loaded
                    (function (f, b, e, v, n, t, s) {
                        if (f.fbq) return;
                        n = f.fbq = function () {
                            n.callMethod
                                ? n.callMethod.apply(n, arguments)
                                : n.queue.push(arguments);
                        };
                        if (!f._fbq) f._fbq = n;
                        n.push = n;
                        n.loaded = true;
                        n.version = "2.0";
                        n.queue = [];
                        t = b.createElement(e);
                        t.async = true;
                        t.src = v;
                        s = b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t, s);
                        t.onload = resolve;
                    })(
                        window,
                        document,
                        "script",
                        "https://connect.facebook.net/en_US/fbevents.js"
                    );
                });
            };

            const initializePixels = () => {
                if (!window.fbq) return;

                // Initialize both pixels
                window.fbq("init", "1584375811875352"); // Pixel A
                window.fbq("init", "1109423764622443"); // Pixel B
                // Send PageView only to each separately (to avoid duplication)
                // window.fbq("trackSingle", "1584375811875352", "PageView");
                // window.fbq("trackSingleCustom", "1109423764622443", "PageView");
                window.fbq("trackSingle", "1584375811875352", "HHIU-ELTY");
                window.fbq("trackSingleCustom", "1109423764622443", "HHIU-New-ELTY");
            };

            loadFbqScript().then(() => {
                initializePixels();
            });
        }
    }, []);


    useEffect(() => {
        const type = localStorage.getItem("type");
        if (type === "1") {
            const script = document.createElement("script");
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id=AW-818835661";
            document.head.appendChild(script);

            // After the script loads, initialize gtag
            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    window.dataLayer.push(arguments);
                }
                window.gtag = gtag;



                // Retrieve user data from localStorage
                const userData = localStorage.getItem("userData");
                const retrievedData = userData ? JSON.parse(userData) : null;
                // Set user data if available
                window.gtag("js", new Date());
                window.gtag("config", "AW-818835661", {
                    allow_enhanced_conversions: true,
                });

                // set user data if available
                if (retrievedData?.email && retrievedData?.mobile) {
                    window.gtag("set", "user_data", {
                        phone_number: retrievedData.mobile,
                        email: retrievedData.email,
                    });
                }

                // send conversion event
                window.gtag("event", "conversion", {
                    send_to: "AW-818835661/sSFUCI_X3v0aEM3huYYD"
                });

                // custom event (optional)
                window.gtag("event", "form_submit", {
                    send_to: "AW-818835661"
                });


            }

            // Remove userData from localStorage after 4 seconds using a separate function
            function removeUserData() {
                localStorage.removeItem("userData");
            }
            setTimeout(removeUserData, 4000);
        }
        else {
            const script = document.createElement("script");
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id=AW-818835661";
            document.head.appendChild(script);
            // After the script loads, initialize gtag
            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    window.dataLayer.push(arguments);
                }
                window.gtag = gtag;
                // Retrieve user data from localStorage
                const userData = localStorage.getItem("userData");
                const retrievedData = userData ? JSON.parse(userData) : null;
                // Set user data if available
                window.gtag("js", new Date());
                window.gtag("config", "AW-818835661", {
                    allow_enhanced_conversions: true
                });

                // set user data if available
                if (retrievedData?.email && retrievedData?.mobile) {
                    window.gtag("set", "user_data", {
                        phone_number: retrievedData.mobile,
                        email: retrievedData.email,
                    });
                }

                // send conversion event
                window.gtag("event", "conversion", {
                    send_to: "AW-818835661/2d7SCIzX3v0aEM3huYYD"
                });

                // custom event (optional)
                window.gtag("event", "form_submit", {
                    send_to: "AW-818835661"
                });
            }

            // Remove userData from localStorage after 4 seconds using a separate function
            function removeUserData() {
                localStorage.removeItem("userData");
            }
            setTimeout(removeUserData, 4000);
        }
    }, [])

    useEffect(() => {
        (function (c, l, a, r, i, t, y) {
            c[a] =
                c[a] ||
                function () {
                    (c[a].q = c[a].q || []).push(arguments);
                };
            t = l.createElement(r);
            t.async = 1;
            t.src = "https://www.clarity.ms/tag/" + i;
            y = l.getElementsByTagName(r)[0];
            y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", "tjd4nwg3o5");
    }, []);

    return (
        <>
            {/* <Header /> */}
            {/* Inject noscript for non-JS users */}
            <noscript>
                <img
                    src="https://ad.doubleclick.net/ddm/activity/src=8971752;type=invmedia;cat=hhiu-000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?"
                    width="1"
                    height="1"
                    alt=""
                    style={{ display: "none" }}
                />
            </noscript>
            {/* Not Elligble */}
            {showSection === "1" && (
                <section>
                    <div className="container">
                        <div className="thank-you">
                            <button
                                href="/"
                                onClick={handleClick}
                                className="free_back thank_you_back"
                            >
                                <img
                                    src="../dist/img/back_white.svg"
                                    width="12px"
                                    alt="Arrow"
                                />
                                Back
                            </button>
                            <div>
                                <div className="popup-icon">
                                    <img
                                        src="../dist/img/thank-you.svg"
                                        width="77"
                                        height="76"
                                        alt="Thanks"
                                    />
                                </div>
                                <h2>
                                    Thank you for <br /> reaching out to us.
                                </h2>

                                <h3>
                                    We are currently reviewing your profile. <br />
                                    If you meet the eligibility criteria, <br />
                                    our team will get in touch with you shortly.
                                </h3>
                            </div>
                            {/* <p>Please keep your phone line available for this call, within 24 to 48 hrs.
                        <br className="d-none d-md-block"/> 
                        and in case of a missed call, we will establish contact again in 60 minutes. </p> */}
                        </div>
                    </div>
                </section>
            )}
            {/* Self Employed */}
            {showSection === "2" && (
                <section>
                    <div className="container">
                        <div className="thank-you">
                            <button
                                href="/"
                                onClick={handleClick}
                                className="free_back thank_you_back"
                            >
                                <img
                                    src="../dist/img/back_white.svg"
                                    width="12px"
                                    alt="Arrow"
                                />
                                Back
                            </button>
                            <div className="margin-top" style={{ position: "relative" }}>
                                <div className="row justify-content-between borderL">
                                    <div className="col-md-5">
                                        <h2 className="">
                                            Thank you for choosing <br /> ICICI Bank Credit Card
                                        </h2>
                                        <div className="popup-icon">
                                            <img
                                                src="../dist/img/icon15.webp"
                                                width="77"
                                                height="66"
                                                alt="Thanks"
                                            />
                                        </div>

                                        <h3>Our representative will get in touch with you shortly from number starting with 1600 31 XXXX </h3>
                                        <p className="d-desktop">
                                            Please keep your phone line available for this call,
                                            within 24 to 48 hrs. and in case of a missed call, we will
                                            establish contact again in 60 minutes.
                                        </p>
                                        <p className="d-mobile">
                                            Please keep your phone line available for this call,
                                            within 24 to 48 hrs. and in case of a missed call, we will
                                            establish contact again in 60 minutes.
                                        </p>
                                    </div>

                                    <div className="col-md-5">
                                        <div className="mobilebx">
                                            <div className="icon-heading">
                                                <img src="dist/img/approve.svg" alt="" width="46" />
                                                <span>
                                                    Please keep the list of below <br /> documents handy
                                                </span>
                                            </div>
                                            <ol className="orderlist">
                                                <li>PAN Card</li>
                                                <li>
                                                    Aadhar Card- Please ensure that first 8 digits of
                                                    Aadhar number are masked
                                                </li>
                                                <li>Bank Statement (last 1 year)</li>
                                                <li>
                                                    Income tax return document along with competition
                                                    sheet
                                                </li>
                                                <li>Blank Paper and Pen</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
            {/* Salaried Elligible */}
            {showSection === "3" && (
                <section>
                    <div className="container">
                        <div className="thank-you">
                            <button
                                href="/"
                                onClick={handleClick}
                                className="free_back thank_you_back"
                            >
                                <img
                                    src="../dist/img/back_white.svg"
                                    width="12px"
                                    alt="Arrow"
                                />
                                Back
                            </button>
                            <div className="margin-top" style={{ position: "relative" }}>
                                <div className="row justify-content-between borderL">
                                    <div className="col-md-5">
                                        <h2 className="">
                                            Thank you for choosing <br /> ICICI Bank Credit Card
                                        </h2>
                                        <div className="popup-icon">
                                            <img
                                                src="../dist/img/icon15.webp"
                                                width="77"
                                                height="66"
                                                alt="Thanks"
                                            />
                                        </div>

                                        <h3>Our representative will get in touch with you shortly from number starting with 1600 31 XXXX </h3>
                                        <p className="d-desktop">
                                            Please keep your phone line available for this call,
                                            within 24 to 48 hrs. and in case of a missed call, we will
                                            establish contact again in 60 minutes.
                                        </p>
                                        <p className="d-mobile">
                                            Please keep your phone line available for this call,
                                            within 24 to 48 hrs. and in case of a missed call, we will
                                            establish contact again in 60 minutes.
                                        </p>
                                    </div>

                                    <div className="col-md-5">
                                        <div className="mobilebx">
                                            <div className="icon-heading">
                                                <img src="dist/img/approve.svg" alt="" width="46" />
                                                <span>
                                                    Please keep the list of below <br /> documents handy
                                                </span>
                                            </div>
                                            <ol className="orderlist">
                                                <li>PAN Card</li>
                                                <li>
                                                    Aadhar Card- Please ensure that first 8 digits of
                                                    Aadhar number are masked
                                                </li>
                                                <li>Bank Statement (last 3 months)</li>
                                                <li>Salary Slip* (last 3 months)</li>
                                                <li>Blank Paper and Pen</li>
                                            </ol>
                                            <p>
                                                *Please ensure that if your Aadhar card is visible on
                                                the salary slip then first 8 digits of your Aadhar
                                                Number are masked.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
}

export default Thankyou;
